export default {
  filterPlaceholder: 'Filter by state',
  confirmDelete: 'Deleting the state of "{filePathId}" does not delete the log file itself. The next discovery round will find it again and re-import it. Continue?',
  resetSelected: 'Reset selected ({count})',
  confirmBulkDelete: 'Deleting the state of {count} log files does not delete the log files themselves. The next discovery round will find them again and re-import them. Continue?',
};
